import { vxm } from "@/store.vuex";
import { Component, Vue } from "vue-property-decorator";
import { ReferralMessage } from './../../models/referrals/referralmessage';
@Component
export default class MailClientOpener extends Vue {
  mailClientOpener(friendEmail: string) {
    let messageBody : string = "";
    const {
      eventName: subject,
      referralMessages,
    } = vxm.referrals.EmployeeReferralResponse.referralDetail;
    let referralMessagesArr: ReferralMessage []  = referralMessages.filter(msg => msg.type === "01");
    if(referralMessagesArr && referralMessagesArr.length > 0) {
      let body = referralMessagesArr[0].messageBody.replace(/<br\s*\/?>/g, '\r\n');
      messageBody = encodeURIComponent(body);
    }
    window.location.href = `mailto:${friendEmail}?subject=${encodeURIComponent(subject)}&body=${messageBody}`;
  }
}
